export enum InputSize {
  Default = 'default',
  Small = 'small',
  Large = 'large'
}
